import { render, staticRenderFns } from "./AllocationDialog.vue?vue&type=template&id=914b8700&scoped=true"
import script from "./AllocationDialog.vue?vue&type=script&lang=js"
export * from "./AllocationDialog.vue?vue&type=script&lang=js"
import style0 from "./AllocationDialog.vue?vue&type=style&index=0&id=914b8700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914b8700",
  null
  
)

export default component.exports